export const BASE_URL_API = 'https://user-api.vcs-vn.com'

export const MAX_ITEM_PAGE_ORDERS = 20

export const COOKIE_TOKEN_NAME = 'mem_epp_rsid'
